import "./App.scss";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import Admin from "./layout/Admin";
import SuperAdmin from "./layout/SuperAdmin";
import Login from "./pages/Auth/Login/Login";
import ForgottenPassword from "./pages/Auth/ForgottenPassword/ForgottenPassword";
import ResetPassword from "./pages/Auth/ForgottenPassword/ResetPassword";
import history from "./utils/HistoryUtils";
import PrivateRoute from "./config/PrivateRoute";
import { createContext, useEffect, useMemo, useState } from "react";
import StaffUser from "./layout/StaffUser";
import moment from "moment";
import { ThemeProvider } from '@material-ui/core/styles';
import theme, { getTheme } from "./theme";
export const ThemeContext = createContext();

function App() {
  const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const loginUserInfo = JSON.parse(
      window.localStorage.getItem("loginUserInfo")
    );
    if (loginUserInfo && loginUserInfo?.role !== "SUPERADMIN") {
      let expireDate = loginUserInfo?.subscription_expire_date;
      let today = moment(new Date()).format("YYYY-MM-DD");
      if (new Date(moment(expireDate, "DD-MM-YYYY")) > new Date(today)) {
        loginUserInfo.is_plan_expire = false;
      } else {
        loginUserInfo.is_plan_expire = true;
      }
    }
  }, []);


  const [mode, setMode] = useState(localStorage.getItem("themeMode") || "light");

  const toggleTheme = () => {
    setMode((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", next);
      return next;
    });
  };
  const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    document.body.className = mode === 'light' ? 'light-theme' : 'dark-theme';
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgotten-password" component={ForgottenPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <PrivateRoute
              path="/staff"
              component={StaffUser}
              isAuthenticated={(e) => isAuthenticated()}
            />
            <PrivateRoute
              path="/admin"
              component={Admin}
              isAuthenticated={(e) => isAuthenticated()}
            />
            <PrivateRoute
              path="/super-admin"
              component={SuperAdmin}
              isAuthenticated={(e) => isAuthenticated()}
            />
            <Redirect from="/" to="/login" />
          </Switch>
        </Router>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default App;
